export default () => '/signup-confirmed';
